export const BACKUP_CODE_PLACEHOLDER = '- - - - - - - -';
